import React from 'react';
import './TiendaBanner.css';

const TiendaBanner = () => (
  <div className="tienda-banner">
    <p>
      <strong>¿Buscás suplementos o cursos?</strong>{' '}
      La tienda online de Bianca está en camino
    </p>
    <a
      href="https://tienda.bianangelucci.com.ar/"
      className="tienda-banner-chip"
      target="_blank"
      rel="noreferrer"
    >
      Visitá la tienda 
    </a>
  </div>
);

export default TiendaBanner;
